import React from "react";

import styles from "../../styles/components/product/ProductCommunityOutcomes.module.css";

const OutcomeRow = ({ outcome }) => (
  <li className={styles.row}>
    <div className={styles.rowHeader}>
      <span className={styles.outcomeLabel}>{outcome.label}</span>
      {outcome.disagreement && <span className={styles.splitBadge}>Opinions differ</span>}
    </div>
    <div className={styles.sources}>
      <div className={styles.source}>
        <span className={styles.sourceLabel}>Simpary assessment</span>
        {outcome.assessment ? (
          <>
            <span className={styles.sourceValue}>{outcome.assessment.score}/100</span>
            <span className={styles.sourceNote}>{outcome.assessment.basisLabel}</span>
          </>
        ) : (
          <span className={styles.sourceNote}>
            {outcome.communityOwned ? "Owners decide this one" : "Not assessed yet"}
          </span>
        )}
      </div>
      <div className={styles.source}>
        <span className={styles.sourceLabel}>
          {outcome.owners ? outcome.owners.label : "Owners"}
        </span>
        {outcome.owners?.stars != null ? (
          <span className={styles.sourceValue}>{outcome.owners.stars}/5</span>
        ) : (
          <span className={styles.sourceNote}>
            {outcome.owners ? "Mentioned in reviews" : "No owner ratings yet"}
          </span>
        )}
      </div>
    </div>
    {outcome.disagreement && <p className={styles.disagreement}>{outcome.disagreement}</p>}
    {outcome.useCaseLine && <p className={styles.useCase}>{outcome.useCaseLine}</p>}
    {outcome.ownersOnlyNote && !outcome.owners && (
      <p className={styles.note}>{outcome.ownersOnlyNote}</p>
    )}
  </li>
);

const ProductCommunityOutcomes = ({ summary, loading }) => {
  if (loading && !summary) return null;
  if (!summary?.outcomes?.length) return null;

  return (
    <section className={styles.card} aria-labelledby="community-outcomes-title">
      <h3 id="community-outcomes-title" className={styles.title}>
        What owners say vs. our assessment
      </h3>
      <p className={styles.subtitle}>
        {summary.ownerReviewCount > 0
          ? `${summary.ownerReviewCount} owner review${summary.ownerReviewCount === 1 ? "" : "s"}, ${summary.verifiedOwnerCount} from verified owners.`
          : "No owner reviews yet."}
      </p>
      {summary.evidenceLabel && <p className={styles.evidenceLabel}>{summary.evidenceLabel}</p>}
      <ul className={styles.list}>
        {summary.outcomes.map((outcome) => (
          <OutcomeRow key={outcome.key} outcome={outcome} />
        ))}
      </ul>
      {summary.satisfaction?.comparison && summary.satisfaction.reviewCount > 0 && (
        <p className={styles.note}>
          Compared with what they had before: {summary.satisfaction.comparison.better || 0} better,{" "}
          {summary.satisfaction.comparison.same || 0} about the same,{" "}
          {summary.satisfaction.comparison.worse || 0} worse.
        </p>
      )}
    </section>
  );
};

export default ProductCommunityOutcomes;
